"use client";
import Image from "next/image";
import { motion } from "framer-motion";
import { Plus } from "lucide-react";

const brands = [
  "/assets/homePage/brandShow/vivo.png",
  "/assets/homePage/brandShow/timex.png",
  "/assets/homePage/brandShow/syska.png",
  "/assets/homePage/brandShow/reebok.png",
  "/assets/homePage/brandShow/philips.png",
  "/assets/homePage/brandShow/UCB.png",
  "/assets/homePage/brandShow/paper-boat.png",
  "/assets/homePage/brandShow/organic-india.png",
  "/assets/homePage/brandShow/omega.png",
  "/assets/homePage/brandShow/panasonic.png",
  "/assets/homePage/brandShow/SRL.png",
  "/assets/homePage/brandShow/body-shop.png",
];

const BrandShowcase = () => {
  // Responsive frame offset — used by BOTH plus icons and vertical lines so
  // they always sit at the same x. Change one place to move the whole frame.
  const frameLeft = "left-4 sm:left-6 lg:left-10";
  const frameRight = "right-4 sm:right-6 lg:right-10";

  return (
    <section className="relative bg-[#F5F5F7]  sm:pt-14 pt-8 lg:pt-16 flex items-center justify-center px-5 sm:px-6 lg:px-20 grayscale">
      <div className="relative w-full flex flex-col gap-6">
        {/* Top horizontal line with plus icons at the corners */}
        <div className="relative w-full h-[1px] bg-[#EEEEEE]">
          <span
            className={`absolute ${frameLeft} top-1/2 -translate-x-1/2 -translate-y-1/2 z-10 bg-[#EEEEEE] h-5 w-5 flex items-center justify-center`}
          >
            <Plus strokeWidth={1.5} className="text-[#CBCBCB]" size={18} />
          </span>
          <span
            className={`absolute ${frameRight} top-1/2 translate-x-1/2 -translate-y-1/2 z-10 bg-[#EEEEEE] h-5 w-5 flex items-center justify-center`}
          >
            <Plus strokeWidth={1.5} className="text-[#CBCBCB]" size={18} />
          </span>
        </div>

        {/* Vertical lines — span full inner column height so they connect
            the top and bottom plus icons into a complete frame. */}
        <div
          className={`absolute ${frameLeft} inset-y-0 w-[1.5px] -translate-x-1/2 bg-[#EEEEEE] pointer-events-none`}
        />
        <div
          className={`absolute ${frameRight} inset-y-0 w-[1.5px] translate-x-1/2 bg-[#EEEEEE] pointer-events-none`}
        />

        {/* Content row — sits inside the frame */}
        <div className="flex flex-col md:flex-row items-center justify-center gap-6 md:gap-0 mx-8 sm:mx-12 lg:mx-24">
          <div className="w-[160px] text-center lg:w-[150px] lg:mr-20 shrink-0">
            <h2 className="text-[14px] font-normal font-kalam leading-[1.2] tracking-[-1px] text-[#242424]">
              Trusted by fast-growing companies around the world
            </h2>
          </div>

          <div className="relative w-full md:flex-1 overflow-hidden">
            <div className="pointer-events-none absolute inset-y-0 left-0 w-16 sm:w-24 lg:w-32 z-10 bg-gradient-to-r from-[#F5F5F7] via-[#F5F5F7]/80 to-transparent" />
            <div className="pointer-events-none absolute inset-y-0 right-0 w-16 sm:w-24 lg:w-32 z-10 bg-gradient-to-l from-[#F5F5F7] via-[#F5F5F7]/80 to-transparent" />

            <motion.div
              className="flex items-center gap-12 sm:gap-16 lg:gap-20 w-max"
              animate={{ x: ["-50%", "0%"] }}
              transition={{
                ease: "linear",
                duration: 25,
                repeat: Infinity,
              }}
            >
              {brands.map((item, i) => (
                <Image
                  key={i}
                  src={item}
                  alt="brand"
                  width={149}
                  height={96}
                  priority
                  className="h-8 sm:h-12 lg:h-12 w-auto shrink-0"
                />
              ))}
            </motion.div>
          </div>
        </div>

        {/* Bottom horizontal line with plus icons */}
        <div className="relative w-full h-[1px] bg-[#EEEEEE]">
          <span
            className={`absolute ${frameLeft} top-1/2 -translate-x-1/2 -translate-y-1/2 z-10 bg-[#EEEEEE] h-5 w-5 flex items-center justify-center`}
          >
            <Plus strokeWidth={1.5} className="text-[#CBCBCB]" size={18} />
          </span>
          <span
            className={`absolute ${frameRight} top-1/2 translate-x-1/2 -translate-y-1/2 z-10 bg-[#EEEEEE] h-5 w-5 flex items-center justify-center`}
          >
            <Plus strokeWidth={1.5} className="text-[#CBCBCB]" size={18} />
          </span>
        </div>
      </div>
    </section>
  );
};

export default BrandShowcase;
